import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1da07a1e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "caseItem-photo" }
const _hoisted_2 = { class: "photo-box-wrap" }
const _hoisted_3 = { class: "photo-box-1" }
const _hoisted_4 = { class: "photo-box-2" }
const _hoisted_5 = { class: "photo-box-2-top" }
const _hoisted_6 = { class: "photo-box-2-bottom" }
const _hoisted_7 = {
  key: 0,
  class: "caseItem-author"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_skeleton_item = _resolveComponent("el-skeleton-item")!
  const _component_el_skeleton = _resolveComponent("el-skeleton")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["caseItem", { 'case-item-column': _ctx.columnView }])
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createVNode(_component_el_skeleton, {
            class: "fullsize",
            animated: "",
            style: {"--el-skeleton-color":"#AFBEC7"}
          }, {
            template: _withCtx(() => [
              _createVNode(_component_el_skeleton_item, {
                variant: "rect",
                class: "fullsize"
              })
            ]),
            _: 1
          })
        ]),
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createVNode(_component_el_skeleton, {
              class: "fullsize",
              animated: "",
              style: {"--el-skeleton-color":"#8D9EA8"}
            }, {
              template: _withCtx(() => [
                _createVNode(_component_el_skeleton_item, {
                  variant: "rect",
                  class: "fullsize"
                })
              ]),
              _: 1
            })
          ]),
          _createElementVNode("div", _hoisted_6, [
            _createVNode(_component_el_skeleton, {
              class: "fullsize",
              animated: "",
              style: {"--el-skeleton-color":"#6C7D87"}
            }, {
              template: _withCtx(() => [
                _createVNode(_component_el_skeleton_item, {
                  variant: "rect",
                  class: "fullsize"
                })
              ]),
              _: 1
            })
          ])
        ])
      ])
    ]),
    (!_ctx.hideTitle)
      ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
          _createVNode(_component_el_skeleton, {
            animated: "",
            style: {"--el-skeleton-color":"#AFBEC7","display":"flex"}
          }, {
            template: _withCtx(() => [
              _createVNode(_component_el_skeleton_item, {
                variant: "text",
                style: {"height":"14px","margin":"1px 0"}
              })
            ]),
            _: 1
          })
        ]))
      : _createCommentVNode("", true)
  ], 2))
}